import i18n from '../../../i18n';
import { arraySortAscendingFunction, reverseDate } from '../../utilities';

export const getBrpPersonenData = (personsJson, type) => {
    let items = [];
    let fields = [];
    const isBsnSearch = (type === 'RaadpleegMetBurgerservicenummer');

    if (!personsJson) {
        return {
            items,
            fields
        };
    }

    for (let i = 0, l = personsJson.length; i < l; i++) {
        items.push({
            id: i,
            nedGlobeRowId: i, // provide a unique ID column to avoid conflicts with the ID column in the data
            burgerservicenummer: personsJson[i].burgerservicenummer,
            geslachtsnaam: personsJson[i].naam.geslachtsnaam,
            voorvoegsel: personsJson[i].naam.voorvoegsel,
            voorletters: personsJson[i].naam.voorletters,
            voornamen: personsJson[i].naam.voornamen,
            adres: `${personsJson[i].adressering?.adresregel1} ${personsJson[i].adressering?.adresregel2}`,
            geslacht: personsJson[i].geslacht?.code,
            geboortedatum: personsJson[i].geboorte?.datum?.datum ? reverseDate(personsJson[i].geboorte?.datum?.datum) : '',
            ...(personsJson[i].geboorte?.plaats && { geboorteplaats: personsJson[i].geboorte?.plaats?.omschrijving }),
            ...(personsJson[i].overlijden && { overlijdensdatum: personsJson[i].overlijden?.datum?.datum }),
            ...(personsJson[i].overlijden && { overlijdensplaats: personsJson[i].overlijden?.plaats?.omschrijving }),
            ...(personsJson[i].verblijfplaats?.adresseerbaarObjectIdentificatie &&
                { adresseerbaarObjectIdentificatie: personsJson[i].verblijfplaats?.adresseerbaarObjectIdentificatie }),
            ...(personsJson[i].verblijfplaats?.nummeraanduidingIdentificatie &&
                { nummeraanduidingIdentificatie: personsJson[i].verblijfplaats?.nummeraanduidingIdentificatie }),
            ...(personsJson[i].gemeenteVanInschrijving?.code &&
                { gemeenteVanInschrijvingCode: personsJson[i].gemeenteVanInschrijving?.code }),
            ...(personsJson[i].gemeenteVanInschrijving?.omschrijving &&
                { gemeenteVanInschrijvingDesc: personsJson[i].gemeenteVanInschrijving?.omschrijving })
        });
    }

    if (items.length > 0) {
        fields.push(
            {
                key: 'burgerservicenummer',
                label: i18n.t('brp.citizenServiceNumber'),
                sortable: true,
                showField: true
            },
            {
                key: 'geslachtsnaam',
                label: i18n.t('brp.lastName'),
                sortable: true,
                showField: true
            },
            {
                key: 'voorvoegsel',
                label: i18n.t('brp.prefix'),
                sortable: true,
                showField: true
            },
            {
                key: 'voorletters',
                label: i18n.t('brp.initials'),
                sortable: true,
                showField: true
            },
            {
                key: 'voornamen',
                label: i18n.t('brp.firstNames'),
                sortable: true,
                showField: true
            },
            {
                key: 'adres',
                label: i18n.t('brp.address'),
                sortable: true,
                showField: true
            },
            {
                key: 'gemeenteVanInschrijvingCode',
                label: i18n.t('brp.municipalityRegistration'),
                sortable: true,
                showField: isBsnSearch
            },
            {
                key: 'gemeenteVanInschrijvingDesc',
                label: i18n.t('brp.municipalityRegistrationDesc'),
                sortable: true,
                showField: isBsnSearch
            },
            {
                key: 'geslacht',
                label: i18n.t('brp.gender'),
                sortable: true,
                showField: true
            },
            {
                key: 'geboortedatum',
                label: i18n.t('brp.dateOfBirth'),
                sortable: true,
                showField: true
            },
            {
                key: 'geboorteplaats',
                label: i18n.t('brp.birthPlace'),
                sortable: true,
                showField: isBsnSearch
            },
            {
                key: 'overlijdensdatum',
                label: i18n.t('brp.dateOfDeath'),
                sortable: true,
                showField: isBsnSearch
            },
            {
                key: 'overlijdensplaats',
                label: i18n.t('brp.placeOfDeath'),
                sortable: true,
                showField: isBsnSearch
            },
            {
                key: 'adresseerbaarObjectIdentificatie',
                label: i18n.t('brp.addressableObjectId'),
                sortable: true,
                showField: isBsnSearch
            },
            {
                key: 'nummeraanduidingIdentificatie',
                label: i18n.t('brp.numberDesignation'),
                sortable: true,
                showField: isBsnSearch
            }
        );
    }

    // sort items
    items.sort(arraySortAscendingFunction('burgerservicenummer'));

    return {
        items,
        fields: fields.filter(({ showField }) => showField),
        sortBy: 'burgerservicenummer',
        selectable: true
    };
};
